import React from "react";
import { NodeViewWrapper } from "@tiptap/react";

import "./style.scoped.scss";

export default function CheckboxNodeView({ node, updateAttributes, editor }) {
    const { checked } = node.attrs;
    const readonly = !editor.options.editable;

    const toggle = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (readonly) {
            return;
        }

        updateAttributes({ checked: !checked });
    };

    return (
        <NodeViewWrapper
            as="span"
            className="checkbox"
            contentEditable={false}
            data-checked={checked ? "true" : "false"}
            data-readonly={readonly ? "true" : "false"}
        >
            <input
                type="checkbox"
                checked={checked}
                // not `disabled`: it greys out a checked box in review
                aria-disabled={readonly}
                // toggled on mouse down so the selection never enters the node
                onChange={() => {}}
                onMouseDown={toggle}
            />
        </NodeViewWrapper>
    );
}
